// Rate-wise GST breakdown rows — shows "CGST 9%", "SGST 9%" / "IGST 18%"
// per distinct item rate, exactly like a Tally bill summary.
const Row = ({ label, val, testid }) => (
  <div className="flex justify-between text-sm" data-testid={testid}>
    <span className="text-slate-600">{label}</span>
    <span className="font-semibold text-slate-900">{"\u20b9"}{val.toFixed(2)}</span>
  </div>
);

export function GstBreakdown({ items, gstType }) {
  if (gstType === "no_gst") {
    return (
      <div className="flex justify-between text-sm">
        <span className="text-slate-500 italic">Tax</span>
        <span className="font-semibold text-slate-500 italic">Not applicable</span>
      </div>
    );
  }
  const map = {};
  (items || []).forEach((it) => {
    const r = parseFloat(it.gst_rate) || 0;
    const amt = parseFloat(it.amount) || 0;
    if (r > 0 && amt) map[r] = (map[r] || 0) + (amt * r) / 100;
  });
  const rates = Object.entries(map)
    .map(([r, tax]) => ({ rate: parseFloat(r), tax }))
    .sort((a, b) => a.rate - b.rate);
  if (rates.length === 0) return null;
  return (
    <>
      {rates.map(({ rate, tax }) =>
        gstType === "cgst_sgst" ? (
          <div key={rate} className="space-y-0.5">
            <Row label={`CGST ${rate / 2}%`} val={tax / 2} testid={`gst-cgst-${rate}`} />
            <Row label={`SGST ${rate / 2}%`} val={tax / 2} testid={`gst-sgst-${rate}`} />
          </div>
        ) : (
          <Row key={rate} label={`IGST ${rate}%`} val={tax} testid={`gst-igst-${rate}`} />
        )
      )}
    </>
  );
}
